<tiime-input-container
  [class.invalid]="(required && errorMessage?.message) || emailCtrl.hasError('email')"
  [class.fulfilled]="form.controls.length > 0"
  tiimeFormInputContainer
  [required]="required"
  contentId="address"
>
  <label class="label" [class.exposed]="form.controls.length > 0 || emailCtrl.value || inputFocused" for="address">
    {{ label | map: mapToLabel }}
  </label>
  <mat-chip-list id="address" #emailList aria-label="Address">
    @for (emailForm of form.controls; track trackByIndex(i); let i = $index) {
      <mat-chip selectable="false" [removable]="emailForm.controls.canBeDeleted.value" (removed)="removeEmail(i)">
        {{ emailForm.controls.address.value }}
        @if (emailForm.controls.canBeDeleted.value) {
          <mat-icon matChipRemove inline="true" fontSet="fontastic" fontIcon="icon-close-2c-r-24-fontastic"></mat-icon>
        }
      </mat-chip>
    }
    <input
      type="email"
      [formControl]="emailCtrl"
      [matChipInputFor]="emailList"
      [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
      matChipInputAddOnBlur="true"
      (matChipInputTokenEnd)="addEmail($event)"
      (focus)="onFocus()"
      (blur)="onBlur()"
    />
  </mat-chip-list>
  @if (errorMessage?.message) {
    <label class="error-label">
      {{ errorMessage?.message }}
    </label>
  }
  @if (emailCtrl.invalid && !errorMessage?.message) {
    <label class="error-label">L'email renseigné est invalide</label>
  }
</tiime-input-container>
